import * as angular from "angular";
import {IController, ITimeoutService, IWindowService} from "angular";
import * as _ from 'lodash';
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {CustomPanelService} from "../../../commons/services/custom-panel.service";
import {RouteSwapResourceRequestModel} from "../../models/route-swap-resource-request.model";

export class PlanningProjectDraftViewCtrl implements IController {

  project: any;
  draft: any;
  routes: any[];
  analysis: any;
  depots: any;
  jobs: any[];
  resources: any[];


  public isLoading: boolean;
  public leftoverStops: any[];
  public selectedJobIds: any[];
  public selectedResourceIds: any[];
  public selectedLeftoverIds: any[];
  public selectedJobToView: any;
  public selectedRouteToView: any;
  public selectedRouteToViewResource: any;
  public sortJobsSlaType: any;
  public selectedActivityId: any;
  public highlightedActivityId: any;
  public selectedRouteId: any;
  public hiddenRouteIds: any[];
  public selectedTab: any;
  public canEdit: boolean;
  public isGroupedRoutes: any;
  public filterConfig: {
    queryString: string,
    jobsSelectedSkills: any,
    jobsSelectedResourceIds: any,
    selectedServiceAreasIds: any,
    jobsSelectedTagNames: any,
    resourcesSelectedSkills: any,
    jobsInRouteQuery: any,
    jobsIsPackedQuery: any,
    resourcesInRouteQuery: any
  };
  public isTimelineFullScreen: boolean;
  public timelineEnabled: boolean;
  public serviceAreas: any[];
  public selectedJobs: any[];
  public sortBy: any;
  public sortByType: any = 'asc';

  private draftRef: any;
  private draftRoutesRef: any;
  private serviceAreasRef: any;
  private jobSourceTypes: any;
  private resourceAgentSkills: any;
  public leftoverJobs: any;
  private currentlyFetchingRouteIds = [];
  private selectedActivityData: any;
  private selectedActivityRouteData: any;
  private selectedRouteToViewInMiniSection: any;
  private routeWarningsRef: any;
  private selectedOverviewType: string = 'draft';
  private accountsRef: any;
  private isDuplicateDraftDisabled: boolean;

  /* @ngInject */
  constructor(private $serviceArea, private planningConstants, private agentConstants, private planningDraftsService: PlanningDraftsService,
              private $log, private planningDialogService: PlanningDialogService, private TimelineService, private $drafts, private customPanelService: CustomPanelService,
              private $draftRoutes, private $state, private confirmDialogService: ConfirmDialogService, private $timeout: ITimeoutService,
              private planningAlertsService: PlanningAlertsService, private $filter, private splitService: SplitService, private analyticsService: AnalyticsService,
              private $window: IWindowService, private $accounts: $accountsFactory, private moment, private $scope: angular.IScope) {
    this.serviceAreasRef = this.$serviceArea();
    this.accountsRef = this.$accounts();
    this.jobSourceTypes = this.planningConstants.jobsSourceTypes;
    this.resourceAgentSkills = this.agentConstants.skills;
    this.draftRoutesRef = this.$draftRoutes();

  }

  $onInit() {
    this.isLoading = false;
    this.leftoverStops = [];
    this.selectedJobIds = [];
    this.selectedJobs = [];
    this.selectedResourceIds = [];
    this.selectedLeftoverIds = [];
    this.selectedJobToView = undefined;
    this.selectedRouteToView = undefined;
    this.selectedRouteToViewResource = undefined;
    this.selectedActivityId = undefined;
    this.highlightedActivityId = undefined;
    this.selectedRouteId = undefined;
    this.hiddenRouteIds = [];
    this.selectedTab = undefined;

    this.canEdit = true;
    this.isGroupedRoutes = true; // Is bundled routes or regular (group/ungroup routes)

    this.filterConfig = {
      queryString: undefined,
      jobsSelectedSkills: undefined,
      jobsSelectedResourceIds: undefined,
      selectedServiceAreasIds: undefined,
      jobsSelectedTagNames: undefined,
      resourcesSelectedSkills: undefined,
      jobsInRouteQuery: undefined,
      jobsIsPackedQuery: undefined,
      resourcesInRouteQuery: undefined
    }
    this.sortJobsSlaType = 'desc';

    this.isTimelineFullScreen = false;
    this.timelineEnabled = true;

    if (!this.jobs) {
      this.jobs = [];
    }

    if (!this.resources) {
      this.resources = [];
    }

    if (!this.routes) {
      this.routes = [];
    }

    if (!this.serviceAreas) {
      this.serviceAreas = [];
    }

    // If there is a loader on Remove it
    if (document.body.classList.contains('md-dialog-is-showing')) {
      document.body.classList.remove("md-dialog-is-showing");
    }

    // ctrl.hiddenRouteIds = _.map(ctrl.routes, 'id');

    // Init Draft - Jobs
    this.jobs = this._getSortedJobs(this.jobs);
    this._setServiceAreasByJobs(this.jobs);

    // Init Draft - Resources
    this._getDraftResources(); // TODO Check if can be removed... if creating a new route there is no resources to choose from.

    // Init Draft
    this._setDraftData(this.draft, true);
    this._bindDraftEventListener();
    this._bindDraftRoutesEventListener();
  }

  $onDestroy() {
    // Safety net: draftRef.$destroy() below kills the websocket ref that would eventually deliver
    // the OPTIMIZED status update that closes this loader. If we navigate away while it's still
    // showing (status IN_PROGRESS), that update never arrives - close it now, before this view's
    // container is torn down, so $mdDialog isn't left with a DOM node destroyed out from under it.
    this.planningDialogService.draftOptimizingLoader(false);

    if (this.draftRef) {
      this.draftRef.$destroy();
    }

    if (this.draftRoutesRef) {
      this.draftRoutesRef.$destroyChannel();
    }
  }

  // ******************************
  //        Public methods
  // ******************************

  // Draft Side Bar
  onTabSelection(tab) {

    if (tab !== this.selectedTab) {

      // this.selectedJobIds = [];
      // this.selectedLeftoverIds = [];
      // this.selectedResourceIds = [];
      this.selectedJobToView = undefined;

      this.filterConfig.queryString = undefined;
      this.filterConfig.jobsSelectedSkills = undefined;
      this.filterConfig.jobsSelectedResourceIds = undefined;
      this.filterConfig.selectedServiceAreasIds = undefined;
      this.filterConfig.resourcesSelectedSkills = undefined;
      this.filterConfig.jobsInRouteQuery = undefined;
      this.filterConfig.jobsIsPackedQuery = undefined;
      this.filterConfig.resourcesInRouteQuery = undefined;

      if (_.isEqual(tab, 'Services')) {
        if (this.jobs.length < _.get(this.draft, 'totals.totalJobsCount')) {
          this.jobs = [];
          this.isLoading = true;
          this._getDraftJobs()
            .then((jobs) => {
              this.jobs = this._getSortedJobs(jobs);
              this._setServiceAreasByJobs(this.jobs);
            })
            .finally(() => {
              this.isLoading = false;
            })
        } else {
          this.jobs = this._getSortedJobs(this.jobs);
          this._setServiceAreasByJobs(this.jobs);
        }
      }

      // if (_.isEqual(tab, 'Resources') && ctrl.resources.length < _.get(ctrl.draft, 'totals.totalResourcesCount')) {
      if (_.isEqual(tab, 'Resources')) {
        this.resources = [];
        this._getDraftResources();
      }
      // this.timelineEnabled = true;
    }
    if (tab !== 'TotalsBar') {
      this.timelineEnabled = false;
    }
    this.selectedTab = tab !== this.selectedTab ? tab : undefined;
    if (!this.selectedTab) {
      this.timelineEnabled = true;
    } else {
      this.selectedOverviewType = undefined;
    }
    this.selectedRouteToView = undefined;
    this.selectedRouteToViewResource = undefined;
  }

  onChangeRouteFilter(value: boolean | undefined) {
    this.filterConfig.jobsInRouteQuery = value;
  }

  onToggleDraftOverview(value) {
    this.selectedOverviewType = value !== this.selectedOverviewType ? value : undefined;
  }

  onQueryChanged(query) {
    this.filterConfig.queryString = query;
  }

  onJobsFiltersChange(skills, serviceAreaIds, tagNames, resourceIds, inRoute, isPacked) {
    this.filterConfig.jobsSelectedSkills = skills;
    this.filterConfig.selectedServiceAreasIds = serviceAreaIds;
    this.filterConfig.jobsSelectedTagNames = tagNames;
    this.filterConfig.jobsSelectedResourceIds = resourceIds;
    this.filterConfig.jobsInRouteQuery = inRoute;
    this.filterConfig.jobsIsPackedQuery = isPacked;
  }

  onSortJobsSlaTypeChange(sortJobsSlaType) {
    this.sortJobsSlaType = sortJobsSlaType;
    this.jobs = this._getSortedJobs(this.jobs);
  }

  onSortByChange(sortBy, sortByType) {
    this.sortBy = sortBy;
    this.sortByType = sortByType;
    this.jobs = this._getSortedJobs(this.jobs);
  }


  onSelectedJobsChange(jobIds) {
    this.selectedJobIds = jobIds;
    this._setSelectedLeftoverIds(jobIds);
    this.jobs = this._getSortedJobs(this.jobs);

    this.setSelectedJobs();
  }

  onViewJob(jobId) {
    this.selectedTab = 'Services';

    const job = _.find(this.jobs, (j) => {
      return j.id === jobId;
    })

    if (job) {
      this.selectedJobToView = job;
      this.timelineEnabled = false;
    } else {
      this.isLoading = true;
      this._getDraftJobs([jobId])
        .then((jobs) => {
          const updatedJobs = this.jobs.concat(jobs);
          this.jobs = this._getSortedJobs(updatedJobs);
          this.selectedJobToView = jobs[0];
          this._setServiceAreasByJobs(this.jobs);
        })
        .finally(() => {
          this.isLoading = false;
        })
    }
  }

  onAddJobs(includeIds) {
    this.planningDraftsService.updateDraftJobs(this.project.id, this.draft.id, includeIds, undefined)
      .then(() => {
        this._resetSelectedJobs();
      });
  }

  onRemoveJobs(excludeIds) {
    this.planningDraftsService.updateDraftJobs(this.project.id, this.draft.id, undefined, excludeIds)
      .then(() => {
        this._resetSelectedJobs();
      });
  }

  onMoveToLeftovers(jobIds) {
    const jobRoutes = _.filter(this.routes, (r) => {
      return (_.intersection(r.jobIds, jobIds)).length > 0;
    })

    const payloads = _.map(jobRoutes, (route) => {
      return {id: route.id, remove: _.intersectionWith(route.jobIds, jobIds, _.isEqual)}
    })

    this.onRemoveActivitiesFromRoutes(payloads);
  }

  // Resources

  onResourcesFiltersChange(skills, serviceAreaIds, inRoute) {
    this.filterConfig.resourcesSelectedSkills = skills;
    this.filterConfig.selectedServiceAreasIds = serviceAreaIds;
    this.filterConfig.resourcesInRouteQuery = inRoute;
  }

  onSelectedResourcesChange(ids) {
    this.selectedResourceIds = ids;
    // this.resources = this._getSortedResources(this.resources);
  }

  onAddResources(includeIds) {
    this.planningDraftsService.updateDraftResources(this.project.id, this.draft.id, includeIds, undefined)
      .then(() => {
        this.selectedResourceIds = [];
      });
  }

  onRemoveResources(excludeIds) {
    this.planningDraftsService.updateDraftResources(this.project.id, this.draft.id, undefined, excludeIds)
      .then(() => {
        this.selectedResourceIds = [];
      });
  }

  // Draft

  // onSetSelectedDraftInProject() {
  //   if (this.project.selectedDraftId !== this.draft.id) {
  //     this.planningProjectsService.setSelectedDraft(this.project.id, this.draft.id)
  //       .then((selectedDraft) => {
  //         this.project.selectedDraftId = selectedDraft.id;
  //       })
  //   }
  // }

  onToggleGroupedRoutes() {
    this.isGroupedRoutes = !this.isGroupedRoutes;
    this._getDraftRoutes()
      .then((updatedRoutes: any) => {
        this.routes = updatedRoutes;
        this.hiddenRouteIds = _.map(this.routes, 'id');

        if (this.selectedRouteToView) {
          this.selectedRouteToView = _.find(updatedRoutes, (r) => {
            return r.id === this.selectedRouteToView.id;
          })
          this.selectedRouteToViewResource = this.resources.find((rs) => {
            return this.selectedRouteToView.resourceId === rs.id
          })
        }
        this._updateDraftJobs(this.draft);
      })
  }


  onExportDraftSvg(exportType) {
    this.planningDraftsService.exportDraft(this.project.id, this.draft.id, exportType);

  }

  // onEditDraftSettings(event) {
  //   this.planningDialogService.editSettings(this.draft.settings, this.depots, undefined, undefined, event)
  //     .then((editedSettings) => {
  //       this._updateDraftSettings(editedSettings);
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed')
  //     })
  // }

  onDeleteDraft(event) {
    this.confirmDialogService.confirm('Delete Draft', 'Are you sure you want to delete draft?', event)
      .then(() => {
        this._deleteDraft();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onApproveAndDispatchDraft($event) {
    this.planningDialogService.approveAndDispatch($event)
      .then((payload) => {
        this._approveAndDispatch(this.draft.id, payload.dispatchLeftovers, payload.autoAssignRoutes, payload.keepProjectOpen);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onOptimizeDraft(event) {
    this.planningDialogService.draftOptimizingLoader(true, this.project.id, this.draft);
    this.planningDraftsService.optimizeDraft(this.draft.id, this.project);
  }

  onDuplicateDraft(event: any) {
    this.isDuplicateDraftDisabled = true;
    this.planningDraftsService.duplicateDraft(this.draft.id, this.project.id)
      .then((duplicatedDraft: any) => {
        this.$state.go('.', {draftId: duplicatedDraft.id}, {notify: true, reload: true});
      })
      .finally(() => {
        this.isDuplicateDraftDisabled = false;
      });
  }

  onCreateRouteByJobs(jobIds, $event) {
    const skills = this._getJobSkillsByIds(jobIds);
    const availableResources = this._getAvailableResources(false, skills);

    if (!availableResources.length) {
      this.planningAlertsService.noAvailableResourcesInfo();
    } else {
      this.planningDialogService.createRouteToDraft(availableResources, this.selectedJobs, this.project.id, $event)
        .then((resource) => {
          this._createRouteToDraft(resource.id, jobIds);
          this._resetSelectedJobs();
        })
        .catch((err) => {
          this.$log.info('Dialog Closed', err)
        })
    }

  }


  onUpdateRouteByJobs(jobIds, $event) {
    const skills = this._getJobSkillsByIds(jobIds);
    const matchedRoutes = this._getAvailableRoutes(skills);

    if (!matchedRoutes.length) {
      this.planningAlertsService.noAvailableRoutesInfo();
    } else {
      // var hasLeftovers = !!ctrl.leftoverJobs.length;
      this.planningDialogService.updateRouteToDraft(matchedRoutes, this.selectedJobs, this.draft.settings.considerVehicleTypes, $event)
        .then((payload) => {
          // payload - optimize/route

          const stopsToAdd = _.chain(this.jobs)
            .filter((j) => {
              return _.includes(jobIds, j.id);
            })
            .map('stops')
            .flatten()
            .value();

          const order = _.uniq(payload.route.stopsOrder.concat(_.map(stopsToAdd, 'id')));
          this.onAddStopsToRoute(payload.route.id, jobIds, order, payload.optimize);
          this._resetSelectedJobs();
        })
        .catch((err) => {
          this.$log.info('Dialog Closed', err)
        })
    }

  }

  onCreateRouteByResource(resourceId, jobIds) {
    this._createRouteToDraft(resourceId, jobIds);
  }


  onViewRouteByResource(resource) {
    this.selectedTab = 'Resources';
    this.selectedRouteToView = _.find(this.routes, (r) => {
      return _.get(r, 'resourceId') === resource.id;
    });
    this.selectedRouteToViewResource = this.resources.find((rs) => {
      return this.selectedRouteToView.resourceId === rs.id
    })
  }

  onViewRouteMiniSection(routeId) {
    const routeWarnings = _.get(this.analysis, 'routeWarnings', {});
    this.routeWarningsRef = routeWarnings[routeId];
    this.selectedOverviewType = 'route'

    const routeRef = _.find(this.routes, function (r) {
      return r.id === routeId;
    });
    this.selectedRouteToViewInMiniSection = routeRef;
    this.selectedRouteToView = routeRef;
    this.selectedRouteToViewResource = this.resources.find((rs) => {
      return this.selectedRouteToView.resourceId === rs.id
    })
  }

  onViewRoute(routeId) {
    this.selectedTab = 'Resources';
    this.selectedRouteToView = undefined;
    this.selectedRouteToViewResource = undefined;
    this.$timeout(500).then(() => {
      this.selectedRouteToView = _.find(this.routes, function (r) {
        return r.id === routeId;
      });
      this.selectedRouteToViewResource = this.resources.find((rs) => {
        return this.selectedRouteToView.resourceId === rs.id
      })

    })
    // if (this.selectedRouteToView) {
    //   this.timelineEnabled = false;
    // }
  }

  onActivitySelection(activity) {
    if (activity) {
      const route = _.find(this.routes, (r) => {
        return r.id === activity.routeId;
      });
      this.selectedActivityId = activity.id;
      this.selectedActivityData = activity;
      this.selectedActivityRouteData = route;
      this.selectedOverviewType = 'activity'
    } else {
      this.selectedActivityData = undefined;
      this.selectedActivityRouteData = undefined;
      this.selectedActivityId = undefined;
    }
  }

  onCloseViewRoute() {
    this.selectedTab = this.resources.length ? 'Resources' : undefined;
    this.selectedRouteToView = undefined;
    this.selectedRouteToViewResource = undefined;

  }

  onSaveDraftSettings(updatedSettings, name) {
    const draftCopy = angular.copy(this.draft);
    draftCopy.settings = updatedSettings;
    draftCopy.name = name;

    this._updateDraft(draftCopy);
  }

  onSaveAndReoptimizeDraftSettings(updatedSettings, name) {
    const draftCopy = angular.copy(this.draft);
    draftCopy.settings = updatedSettings;
    draftCopy.name = name;

    this._updateDraftAndReoptimize(draftCopy);
  }

  onRemoveActivitiesFromRoutes(payload) {
    this.planningDraftsService.moveActivityInRoutes(payload, this.project, this.draft.id, this.isGroupedRoutes)
      .then((updatedRoutes: any) => {
        this.routes = _.unionBy(updatedRoutes, this.routes, 'id');
        this._resetSelectedJobs();
      })
  }

  // Map Interactions

  onRoutedJobSelect(jobId) {
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, function (id) {
        return id !== jobId;
      })
    }
    this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();


  }

  onHiddenRouteIdsChange(ids) {
    this.hiddenRouteIds = ids;
  }

  onSelectRoute(routeId) {
    this.selectedRouteId = routeId;
  }

  // Timeline
  onToggleRouteDisplay(id, isEnabled) {
    if (isEnabled) {
      this.hiddenRouteIds = _.filter(this.hiddenRouteIds, (rid) => {
        return rid !== id;
      })
    } else {
      this.hiddenRouteIds = this.hiddenRouteIds.concat([id]);
    }
  }

  onAddStopsToRoute(routeId, jobIds, order, doOptimization, allowSkillsMismatch?: boolean) {
    this.planningDraftsService.addStopsToRoute(routeId, jobIds, order, doOptimization, this.project, this.draft.id, allowSkillsMismatch)
      .then((updatedRoutes: any) => {
        this.routes = _.unionBy(updatedRoutes, this.routes, 'id');
      })
  }

  onRecalcRoute(routeId, ignoreSequence, event) {
    this.planningDraftsService.recalcRoutesInDraft(this.project, this.draft.id, [routeId], ignoreSequence)
      .then(() => {
        this.planningDialogService.draftOptimizingLoader(true, this.project.id, this.draft);
      })
  }

  onRecalcRoutes(resourceIds) {
    const routeIds = _.chain(this.routes)
      .filter((r) => {
        return _.includes(resourceIds, r.resourceId);
      })
      .map((filteredRoutes) => {
        return filteredRoutes.id
      })
      .value();

    this.planningDraftsService.recalcRoutesInDraft(this.project, this.draft.id, routeIds)
      .then(() => {
        this.planningDialogService.draftOptimizingLoader(true, this.project.id, this.draft);
      })
  }

  onDeleteRoutes(routeIds) {
    // Get resource IDs from routes being deleted
    const deletedRoutes = _.filter(this.routes, (r) => {
      return _.includes(routeIds, r.id);
    });
    const deletedRouteResourceIds = _.map(deletedRoutes, 'resourceId');

    this.planningDraftsService.deleteRoutesInDraft(routeIds, this.project.id, this.draft.id)
      .then((deletedRouteIds) => {
        this.routes = _.filter(this.routes, (r) => {
          return !_.includes(deletedRouteIds, r.id);
        })
        this.selectedResourceIds = [];

        // Update resources' routed flag to false for deleted routes
        // Create new array reference for Angular change detection
        // Only for non-vehicle resources (vehicle resources have amount tracking instead)
        this.resources = _.map(this.resources, (resource) => {
          if (_.includes(deletedRouteResourceIds, resource.id) && resource.source !== 'Vehicle') {
            return {...resource, routed: false};
          }
          return resource;
        });
      })
  }

  onToggleLockRoute(id, locked) {
    this.planningDraftsService.updateRouteLockState(this.project.id, this.draft.id, id, !!locked)
      .then((updatedRoutes: any) => {
        const routesCopy = angular.copy(this.routes);
        const routeIndex = _.findIndex(routesCopy, (r) => {
          return r.id === id;
        })

        if (routeIndex > -1) {
          routesCopy[routeIndex].locked = !routesCopy[routeIndex].locked;
          routesCopy[routeIndex].updatedAt = this.moment().valueOf();

          const updatedJobIds = _.flatMap(routesCopy[routeIndex], 'jobIds');
          _.forEach(this.jobs, (j) => {
            if (_.includes(updatedJobIds, j.id)) {
              j.locked = !locked;
            }
          })

          const updatedResourceIds = _.map(routesCopy[routeIndex], 'resource.id');
          _.forEach(this.resources, (r) => {
            if (_.includes(updatedResourceIds, r.id)) {
              r.locked = !locked;
            }
          })

        }
        this.routes = routesCopy;
      })
  }

  onDispatchRoutes(resourceIds) {
    const routeIds = _.chain(this.resources)
      .filter(r => {
        return _.includes(resourceIds, r.id)
      })
      .map(filteredResource => {
        return filteredResource.routeId
      })
      .value();

    this.planningDraftsService.approveAndDispatchRoutes(this.draft.id, this.project.id, routeIds)
      .then((res) => {

      })
  }

  onPrintRoutes(resourceIds) {
    const routeIds = _.chain(this.resources)
      .filter(r => {
        return _.includes(resourceIds, r.id)
      })
      .map(filteredResource => {
        return filteredResource.routeId
      })
      .value();

    const routesSyncIds = _.chain(this.routes)
      .filter(r => {
        return _.includes(routeIds, r.id)
      })
      .map(filteredRoute => {
        return filteredRoute.syncId
      })
      .value();

    if (routesSyncIds.length) {
      const siteId = this.splitService.getSiteId();
      const url = this.$state.href('print.routes', {syncIds: routesSyncIds, siteId: siteId});
      this.analyticsService.trackEvent('Routes Actions', 'Print Routes', 'Click');
      this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    }
  }

  onPrintRoutesLoadingSheet(resourceIds) {
    const routeIds = _.chain(this.resources)
      .filter(r => {
        return _.includes(resourceIds, r.id)
      })
      .map(filteredResource => {
        return filteredResource.routeId
      })
      .value();

    const routesSyncIds = _.chain(this.routes)
      .filter(r => {
        return _.includes(routeIds, r.id)
      })
      .map(filteredRoute => {
        return filteredRoute.syncId
      })
      .value();

    if (routesSyncIds.length) {
      const siteId = this.splitService.getSiteId();
      const url = this.$state.href('print.loading-sheets', {syncIds: routesSyncIds, siteId: siteId});
      this.analyticsService.trackEvent('Routes Actions', 'Print Loading Sheet', 'Click');
      this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    }
  }

  onDeleteRoutesByResourceIds(resourceIds) {
    const routesToDelete = _.filter(this.routes, (r) => {
      return _.includes(resourceIds, _.get(r, 'resourceId'));
    });
    this.onDeleteRoutes(_.map(routesToDelete, 'id'));
  }


  onMoveActivity(jobIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, allowSkillsMismatch?: boolean) {
    const payload = this.TimelineService.getMovedTaskPayload(jobIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);
    // PlanningDialogService.draftOptimizingLoader(true, ctrl.project.id, ctrl.draft.id);
    this.planningDraftsService.moveActivityInRoutes(payload, this.project, this.draft.id, this.isGroupedRoutes, allowSkillsMismatch)
      .then((updatedRoutes: any) => {
        this.routes = _.unionBy(updatedRoutes, this.routes, 'id');
      })
  }

  onActivityHighlight(activityId) {
    this.highlightedActivityId = activityId;
  }

  onRemoveActivityFromRoute(routeId, jobIds) {
    const payload = [{id: routeId, remove: jobIds}];
    this.planningDraftsService.moveActivityInRoutes(payload, this.project, this.draft.id, this.isGroupedRoutes)
      .then((updatedRoutes: any) => {
        this.routes = _.unionBy(updatedRoutes, this.routes, 'id');
      })
  }

  onToggleTimeline() {
    this.timelineEnabled = !this.timelineEnabled;

    if (!this.timelineEnabled) {
      this.isTimelineFullScreen = false;
    }
    // else {
    //   this.selectedTab = ""
    // }
  }

  onTimelineFullScreen() {
    this.isTimelineFullScreen = !this.isTimelineFullScreen;
    this.timelineEnabled = true;

    const timelineElement = document.getElementById('planning-timeline');
    const height = this.isTimelineFullScreen ? window.innerHeight : (window.innerHeight / 2);
    timelineElement.style.height = height + 'px';
  }

  // Leftovers
  onLeftOverJobSelect(jobId) {
    this.$log.info(jobId);
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, function (id) {
        return id !== jobId;
      })
    }
    this._setSelectedLeftoverIds(this.selectedJobIds);
    this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();
  }

  onLeftOverMultipleJobSelect(jobIds) {

    //If some are not selected yet select all of them else remove all of them.
    if (!!_.difference(jobIds, this.selectedJobIds).length) {
      this.selectedJobIds = _.uniq(_.concat(this.selectedJobIds, jobIds));
    } else {
      this.selectedJobIds = _.difference(this.selectedJobIds, jobIds);
    }

    this._setSelectedLeftoverIds(this.selectedJobIds);
    this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();
  }

  setAllLeftOverSelection(isSelectAll) {
    this.selectedJobIds = isSelectAll ? _.map(this.leftoverJobs, 'id') : [];
    this._setSelectedLeftoverIds(this.selectedJobIds);
    this.setSelectedJobs();
  }

  viewActivityPackages() {
    this.selectedOverviewType = 'activityPackages';
  }

  viewServiceAreas(serviceAreaIds) {
    this.serviceAreasRef.$asyncValues(serviceAreaIds)
      .then((serviceAreas) => {
        this.selectedOverviewType = 'serviceAreas';
        this.selectedActivityData.serviceAreas = serviceAreas;
      })
  }

  viewAccounts(accountIds) {
    this.accountsRef.$asyncValues(accountIds)
      .then((accounts) => {
        this.selectedOverviewType = 'accounts';
        this.selectedActivityData.accounts = accounts;
      })
      .catch((error) => {
        this.$log.error('Failed to get branches', error);
      })
  }

  onCloseExtraDataOverview() {
    this.selectedOverviewType = 'activity'
  }

  onChangeRouteResource(routeId, $event) {
    const resourcesOptions = _.map(angular.copy(this.resources), (r) => {
      const skillsString = _.map(r.allocationSkills, (s) => {
        return this.$filter('translate')('SKILLS.' + s)
      }).join(', ');
      r.allocationName = `${r.allocationName || r.vehicleName} (${skillsString})`
      return r;
    })
    const data = {optionsWrapper: {list: resourcesOptions, propertyRef: 'allocationName'}};
    const routeRef = _.find(this.routes, (r) => {
      return r.id === routeId;
    })
    const currentResourceId = routeRef.resource?.id;

    this.customPanelService.open($event, data, currentResourceId, (updatedResourceId: string) => {

      if (!updatedResourceId || (currentResourceId === updatedResourceId)) {
        return;
      }

      const payload: RouteSwapResourceRequestModel[] = [{
        routeId: routeId,
        originalResourceId: _.get(routeRef, 'resource.id'),
        destinationResourceId: updatedResourceId
      }]

      const swapRouteFrom = _.find(this.routes, (r) => {
        return r.resource?.id === updatedResourceId;
      })

      if (!!swapRouteFrom) {
        payload.push({
          routeId: swapRouteFrom.id,
          originalResourceId: _.get(swapRouteFrom, 'resource.id'),
          destinationResourceId: _.get(routeRef, 'resource.id')
        })
      }

      this.planningDraftsService.swapRouteResources(this.project.id, this.draft.id, payload)
        .then((updatedRoutes: any[]) => {
          const routesCopy = angular.copy(this.routes);
          updatedRoutes.forEach((r) => {
            const routeIndex = routesCopy.findIndex((route) => {
              return route.id === r.id;
            })

            if (routeIndex > -1) {
              routesCopy[routeIndex] = r;
            }
          })

          this.routes = routesCopy;
        })
    })
  }


  // ******************************
  //        Private methods
  // ******************************


  private _bindDraftEventListener() {
    this.draftRef = this.$drafts(this.draft.id);
    this.draftRef.$registerOnUpdateHandler(this.$scope, (updatedDraft) => {

      if (_.isEqual(this.draft.id, updatedDraft.id) &&
        (!_.isEqual(this.draft.updatedAt, updatedDraft.updatedAt) && (updatedDraft.updatedAt > this.draft.updatedAt))) {
        this._setDraftData(updatedDraft, undefined);
      }

    })
  }

  private _bindDraftRoutesEventListener() {
    this.draftRoutesRef.$subscribeChannel(this, (routes) => {
      const currentRouteIds = _.map(this.routes, 'id');
      const routesToUpdate = _.filter(routes, (r) => {
        if (!_.isEqual(r.draftId, this.draft.id) || !_.includes(currentRouteIds, r.id)) {
          return false
        } else {
          var routeRef = _.find(this.routes, (route) => {
            return route.id === r.id;
          })
          return routeRef && r.updatedAt > routeRef.updatedAt;
        }
      })

      this.$log.info('Draft View Routes:', routes);

      if (routesToUpdate.length) {
        var routeIdsToFetch = _.difference(_.map(routesToUpdate, 'id'), this.currentlyFetchingRouteIds);

        if (routeIdsToFetch.length) {
          this.currentlyFetchingRouteIds = _.uniq(_.concat(routeIdsToFetch, this.currentlyFetchingRouteIds))

          this._getDraftRoutes(routeIdsToFetch)
            .then((updatedRoutes: any) => {
              let routesCopy = angular.copy(this.routes) || [];

              _.forEach(updatedRoutes, (r) => {
                const routeIndex = _.findIndex(routesCopy, (route) => {
                  return route.id === r.id;
                })
                if (routeIndex > -1) {
                  routesCopy[routeIndex] = r;
                }
              })

              this.routes = _.uniqBy(routesCopy, 'id');
              this.currentlyFetchingRouteIds = _.difference(this.currentlyFetchingRouteIds, routeIdsToFetch);
            })
        }
      }

    })
  }

  private _setDraftData(updatedDraft, hideRoutes?) {
    this.draft = updatedDraft;

    this.$log.info('Draft View:', updatedDraft);

    // Draft Statuses - SCHEME/IN_PROGRESS/OPTIMIZED/COMPLETED
    if (updatedDraft.status === 'IN_PROGRESS') {
      this.planningDialogService.draftOptimizingLoader(true, this.project.id, updatedDraft);//TODO ask liron if i can pass 3/4 params
    }

    if (updatedDraft.status === 'OPTIMIZED' || updatedDraft.status === 'SCHEME') {
      this.planningDialogService.draftOptimizingLoader(false);

      //check if jobs changed, change the routed/excluded and set it as needed to be updated.
      this._updateDraftJobs(updatedDraft);
      this._updateDraftResources(updatedDraft, this.resources);

      this._setDraftRoutes(updatedDraft, hideRoutes);
      this._setDraftAnalysis();
      this._setLeftoversByJobIds(updatedDraft.leftoversIds);
    }
  }

  private _setSelectedLeftoverIds(selectedJobIds) {
    const leftoverJobsIds = _.map(this.leftoverJobs, 'id');
    this.selectedLeftoverIds = _.filter(selectedJobIds, (id) => {
      return _.includes(leftoverJobsIds, id);
    })
  }

  private _getSortedJobs(jobs) {
    let routedJobs = [];
    let unRoutedJobs = [];
    let excludedJobs = [];

    _.forEach(jobs, (j) => {
      j.resourceId = undefined;
      j.spotsAmount = this.$filter('orderSpots')(j.packages);
      j.packagesAmount = this.$filter('servicePackagesCount')(j.packages);

      if (j.routed) {
        const route = _.find(this.routes, function (r) {
          return _.includes(r.jobIds, j.id)
        })
        if (route) {
          _.set(j, 'resourceId', route.resourceId);
          _.set(j, 'locked', route.locked);
        }
        routedJobs.push(j)
      }
      if (!j.routed && !j.excluded) {
        unRoutedJobs.push(j)
      }
      if (j.excluded) {
        excludedJobs.push(j)
      }
    })


    routedJobs = _.isUndefined(this.sortJobsSlaType) ?
      _.sortBy(routedJobs, 'routeId') :
      _.orderBy(routedJobs, [this.sortBy], [this.sortByType]);

    const unlockedJobs = _.filter(routedJobs, function (j) {
      return !j.locked;
    });
    const lockedJobs = _.filter(routedJobs, function (j) {
      return j.locked;
    });

    routedJobs = _.concat(unlockedJobs, lockedJobs);
    unRoutedJobs = _.orderBy(unRoutedJobs, [this.sortBy], [this.sortByType]);
    excludedJobs = _.orderBy(excludedJobs, [this.sortBy], [this.sortByType]);

    // return _.orderBy(jobs, ['routed', 'excluded'], ['desc', 'desc']);


    const sortedJobs = _.concat(routedJobs, unRoutedJobs, excludedJobs);

    // all the selected jobs will be on top
    const selectedJobs = _.filter(sortedJobs, (j) => {
      return _.includes(this.selectedJobIds, j.id);
    })
    const unselectedJobs = _.filter(sortedJobs, (j) => {
      return !_.includes(this.selectedJobIds, j.id);
    })
    return _.concat(selectedJobs, unselectedJobs);
    // return _.concat(routedJobs, unRoutedJobs, excludedJobs);
  }

  private _setServiceAreasByJobs(jobs) {
    const areaIds = _.chain(jobs)
      .map('areaIds')
      .flatten()
      .uniq()
      .value();

    if (areaIds.length) {
      this.serviceAreasRef.$asyncValues(areaIds)
        .then((serviceAreas) => {
          this.serviceAreas = _.uniqBy(this.serviceAreas.concat(serviceAreas), 'areaId');
        })
    }
  }

  _getSortedResources(resources) {
    const routedResources = [];
    const unRoutedResources = [];
    const excludedResources = [];

    _.forEach(resources, (r) => {

      r.routeId = undefined;

      if (r.routed) {
        const route = _.find(this.routes, (route) => {
          return _.isEqual(route.resourceId, r.id);
        })
        if (route) {
          _.set(r, 'routeId', route.id);
          _.set(r, 'locked', route.locked);
        }
        routedResources.push(r);
      }
      if (!r.routed && !r.excluded) {
        unRoutedResources.push(r);
      }
      if (r.excluded) {
        excludedResources.push(r);
      }
    })

    const sortedResources = _.concat(routedResources, unRoutedResources, excludedResources);

    // all the selected resources will be on top
    const selectedResources = _.filter(sortedResources, (r) => {
      return _.includes(this.selectedResourceIds, r.id);
    })
    const unselectedResources = _.filter(sortedResources, (r) => {
      return !_.includes(this.selectedResourceIds, r.id);
    })
    return _.concat(selectedResources, unselectedResources);

    // // return _.orderBy(resources, ['routed', 'excluded'], ['desc', 'desc']);
    // return _.concat(routedResources, unRoutedResources, excludedResources);
  }

  private _setDraftRoutes(draft, hideRoutes) {
    const currentRouteIds = _.map(this.routes, 'id');

    const routeIdsToRemove = _.difference(currentRouteIds, draft.routesIds);
    let routeIdsToAdd = _.difference(draft.routesIds, currentRouteIds);
    routeIdsToAdd = _.difference(routeIdsToAdd, this.currentlyFetchingRouteIds)


    if (routeIdsToRemove.length) {
      this.routes = _.filter(this.routes, (r) => {
        return !_.includes(routeIdsToRemove, r.id)
      })
    }

    if (routeIdsToAdd.length) {
      this.currentlyFetchingRouteIds = _.uniq(_.concat(routeIdsToAdd, this.currentlyFetchingRouteIds))
      this._getDraftRoutes(routeIdsToAdd)
        .then((routesToAdd) => {
          this.currentlyFetchingRouteIds = _.difference(this.currentlyFetchingRouteIds, routeIdsToAdd);
          // this.routes = _.uniqBy(this.routes.concat(routesToAdd), 'id');
          this.routes = _.orderBy(_.uniqBy(this.routes.concat(routesToAdd), 'id'), ['resource.allocationName', 'resource.vehicleName'], ['asc']);

          this._updateDraftJobs(this.draft);

          if (hideRoutes) {
            this.hiddenRouteIds = _.map(this.routes, 'id');
          }
        })
    }

  }

  private _setDraftAnalysis() {
    this.planningDraftsService.getDraftAnalysis(this.draft.id)
      .then((analysis) => {
        this.analysis = analysis;
      })
  }

  // private _setJobsByStatus(jobs) {
  //   const map = {
  //     All: [],
  //     NotScheduled: [],
  //     Scheduled: []
  //   };
  //   _.forEach(jobs, (j) => {
  //     const status = j.orderStatus;
  //     if (!map[status]) {
  //       _.set(map, status, [])
  //     }
  //     map[status].push(j);
  //     map.All.push(j);
  //   });
  //   return map;
  // }

  private _deleteDraft() {
    this.planningDraftsService.deleteDraftsFromProject([this.draft.id], this.project)
      .then(() => {
        this.$state.go(this.planningConstants.states.project, {projectId: this.project.id, draftId: undefined});
      })
      .catch((error) => {
        this.$log.error(error);
      })
  }

  // private _onJobsRemoved(ids) {
  //   this.selectedJobIds = [];
  //   this.selectedLeftoverIds = [];
  //   this.jobs = _.filter(this.jobs, (j) => {
  //     return !_.includes(ids, j.id);
  //   });
  //   this._setServiceAreasByJobs(this.jobs);
  // }

  // private _getJobsOutOfProjectScope(project) {
  //   if (!project.jobs) {
  //     return [];
  //   }
  //   return _.filter(project.jobs, (j) => {
  //     const stopsRef = _.get(j, 'stops', []),
  //       jobNotBefore = _.get(stopsRef, '[0].notBefore'),
  //       lastStopRef = stopsRef[stopsRef.length - 1],
  //       jobNotAfter = _.get(lastStopRef, 'notBefore');
  //
  //     if (jobNotBefore && jobNotAfter) {
  //       return jobNotBefore < project.from || jobNotAfter > project.to;
  //     } else {
  //       return false;
  //     }
  //
  //   })
  // }

  private _approveAndDispatch(draftId, dispatchLeftovers, autoAssignRoutes, keepProjectOpen) {
    this.isLoading = true;
    this.planningDraftsService.approveAndDispatchDraft(draftId, this.project, dispatchLeftovers, autoAssignRoutes, keepProjectOpen)
      .then(() => {
      })
      .catch(() => {
        this.isLoading = false;
      })
  }

  private _getJobSkillsByIds(jobIds) {
    const jobs = _.filter(this.jobs, (j) => {
      return _.includes(jobIds, j.id)
    })
    return _.chain(jobs)
      .filter((j) => {
        return !!j.skills
      })
      .map('skills')
      .flatten()
      .uniq()
      .value();
  }

  private _getAvailableResources(isRouted, skills) {
    // const routedResourceIds = _.map(this.routes, 'resourceId');
    return _.filter(this.resources, (resource) => {

      // Check if requested skills included in the resources allocation skills
      if (skills && resource.allocationSkills && _.difference(skills, resource.allocationSkills).length > 0) {
        return false;
      }

      // if (resource.source === 'Vehicle' && !resource.amount) {
      //   return true
      // }
      //
      // const usedCount = _.filter(routedResourceIds, (id) => {
      //   return id === resource.id;
      // }).length;
      //
      // return resource.source === 'Allocations' ?
      //   (resource.routed === isRouted) : (usedCount < resource.amount);
      return true;
    });
  }

  private _getAvailableRoutes(skills) {
    if (!skills) {
      skills = [];
    }

    return _.filter(this.routes, (route) => {
      return _.difference(skills, route.resource.allocationSkills).length === 0;
    });
  }

  private _createRouteToDraft(resourceId, jobIds) {
    if (!jobIds) {
      jobIds = [];
    }
    this.planningDraftsService.createRouteInDraft(resourceId, jobIds, this.project.id, this.draft.id, this.isGroupedRoutes)
      .then((createdRoute: any) => {
        const currentRouteIds = _.map(this.routes, 'id');

        // See if it causes duplicate routes
        if (!_.includes(currentRouteIds, createdRoute.id)) {
          this.routes = this.routes.concat(createdRoute);
        }
      })
  }

  private _getDraftJobs(ids?) {
    return this.planningDraftsService.getJobs(this.project.id, this.draft.id, ids);
  }

  private _getDraftResources() {
    this.isLoading = true;
    this.planningDraftsService.getResources(this.project.id, this.draft.id)
      .then((resources) => {
        this._updateDraftResources(this.draft, resources);
      })
      .finally(() => {
        this.isLoading = false;
      })
  }

  private _getDraftRoutes(routeIds?) {
    return this.planningDraftsService.getRoutes(this.project.id, this.draft.id, routeIds, this.isGroupedRoutes);
  }

  private _setLeftoversByJobIds(leftoversIds) {
    const leftoverJobs = _.filter(this.jobs, (j) => {
      return _.includes(leftoversIds, j.id)
    });
    this.leftoverJobs = this._getSortedJobs(leftoverJobs);
    this.leftoverStops = this._getLeftoverStops(this.leftoverJobs);
  }

  private _getLeftoverStops(jobs) {
    const stops = [];

    _.forEach(jobs, (j) => {
      _.forEach(j.stops, (s) => {
        stops.push(s);
      })
    });
    return stops;
  }

  private _updateDraftJobs(draft) {
    const draftRoutedJobIds = _.get(draft, 'routedJobsIds', []);
    const draftExcludedJobIds = _.get(draft, 'excludedJobsIds', []);

    const updatedJobs = angular.copy(this.jobs);
    _.forEach(updatedJobs, (j) => {
      const route = _.find(this.routes, (route) => {
        return _.includes(route.jobIds, j.id);
      });

      j.routed = _.includes(draftRoutedJobIds, j.id);
      j.excluded = _.includes(draftExcludedJobIds, j.id);
      j.routeId = _.get(route, 'id');
      j.resourceName = _.get(route, 'resource.allocationName') || _.get(route, 'resource.vehicleName');
    })

    this.jobs = this._getSortedJobs(updatedJobs);
    this._setServiceAreasByJobs(this.jobs);
  }

  private _updateDraftResources(draft, resources) {
    const draftRoutedResourceIds = _.get(draft, 'routedResourcesIds', []);
    const draftExcludedResourceIds = _.get(draft, 'excludedResourcesIds', []);

    // Get actual routed resource IDs from existing routes
    const actualRoutedResourceIds = _.map(this.routes, 'resourceId');

    _.forEach(resources, (r) => {
      const route = _.find(this.routes, (route) => {
        return _.get(route, 'resourceId') === r.id;
      });

      // Use actual route existence for routed status, not draft's potentially stale data
      // This ensures resources from deleted routes are immediately available
      r.routed = _.includes(actualRoutedResourceIds, r.id);
      r.routeStatus = _.get(route, 'status');
      r.excluded = _.includes(draftExcludedResourceIds, r.id);
      r.routeId = _.get(route, 'id');
      r.routeTotals = _.get(route, 'totals', {});
    })
    this.resources = this._getSortedResources(resources);
  }

  private _updateDraft(draft) {
    this.planningDraftsService.updateDraft(draft, this.draft.id, this.project)
      .then((updatedDraft) => {
        this.draft = updatedDraft;
      })
  }

  private _updateDraftAndReoptimize(draft) {
    this.planningDraftsService.updateDraft(draft, this.draft.id, this.project)
      .then((updatedDraft) => {
        this.draft = updatedDraft;
        this.selectedTab = undefined;
        this.timelineEnabled = true;
        this.onOptimizeDraft(draft);
      })
  }

  private _updateDraftSettings(settings) {
    this.planningDraftsService.updateDraftSettings(settings, this.draft.id, this.project)
      .then((updatedDraft) => {
        this.draft = updatedDraft;
      })
  }

  private _resetSelectedJobs() {
    this.selectedJobIds = [];
    this.selectedJobs = [];
    this.selectedLeftoverIds = [];
  }


  private setSelectedJobs() {
    this.selectedJobs = _.chain(this.selectedJobIds)
      .map((id) => {
        return _.find(this.jobs, (j) => {
          return j.id === id;
        })
      })
      .compact()
      .value();
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectDraftView', {
    bindings: {
      project: '<',
      draft: '<',
      routes: '<?',
      analysis: '<',
      depots: '<',
      jobs: '<?',
      resources: '<?'
    },
    template: require('./planning-project-draft-view.html').default,
    controller: PlanningProjectDraftViewCtrl
  });

